import { createAvatar } from '@dicebear/core';
import { avataaars } from '@dicebear/collection';

/**
 * Generates an avatar data URI based on the provided style options.
 * Uses the Dicebear avataaars library to create customized user avatars.
 *
 * This utility function creates consistent avatar representations across the application
 * by mapping user-selected style preferences to Dicebear avatar options.
 *
 * @param {Object} values - Avatar style configuration object containing user preferences
 * @returns {string} Data URI string representing the generated avatar image
 */
export const generateAvatar = (values) => {
  // Only include properties that have values to avoid overriding defaults
  const avatarOptions = {
    ...(values.topType && { top: [values.topType] }),
    ...(values.accessories && { accessories: [values.accessories] }),
    ...(values.accessoriesColor && {
      accessoriesColor: [values.accessoriesColor],
    }),
    ...(values.hairColor && { hairColor: [values.hairColor] }),
    ...(values.facialHair && { facialHair: [values.facialHair] }),
    ...(values.facialHairColor && {
      facialHairColor: [values.facialHairColor],
    }),
    ...(values.clothing && { clothing: [values.clothing] }),
    ...(values.clothingColor && { clothesColor: [values.clothingColor] }),
    ...(values.eyes && { eyes: [values.eyes] }),
    ...(values.eyebrows && { eyebrows: [values.eyebrows] }),
    ...(values.mouth && { mouth: [values.mouth] }),
    ...(values.skinColor && { skinColor: [values.skinColor] }),
    randomizedIds: false,
    accessoriesProbability: 100,
    facialHairProbability: 100,
    backgroundColor: ['E5FDF8'],
    radius: 50,
  };

  // Create avatar instance with mapped options
  const avatar = createAvatar(avataaars, avatarOptions);

  // Return data URI for direct use in image src attributes
  return avatar.toDataUri();
};

export default generateAvatar;
